function PageClassManager() {
    this.System = [];

    this.Enrollees = [];
    this.EnrolleesOffenderPrimary = [];
    this.EnrolleesOffenderSecondary = [];
    this.EnrolleesVictimPrimary = [];
    this.EnrolleesVictimSecondary = [];

    this.Events = [];
    this.EventsPrimary = [];

    this.Zones = [];
    this.ZonesPrimary = [];

    this.Analysis = [];
    this.AnalysisIncidentsPrimary = [];
    this.AnalysisIncidentsResults = [];
    this.AnalysisSpatialPrimary = [];

    this.Reports = [];
    this.ReportDetailsPrimary = [];
    this.ReportSchedulesPrimary = [];
    this.ReportSchedulesSecondary = [];

    this.Inventory = [];
    this.InventoryDevicesPrimary = [];
    this.InventoryDeviceClusters = [];

    this.Agents = [];
    this.AgentsDetailsPrimary = [];
    this.AgentsNotificationEscalationPlansPrimary = [];

    this.Initialize = function (aThis) {
        aThis.System.push(new PageClass('Dashboard', 31, 'Dashboard'));
        aThis.System.push(new PageClass('Enrollees', 12, 'Enrollees.Offenders.Profile.Events'));
        aThis.System.push(new PageClass('Events', 1, 'Events.Map'));
        aThis.System.push(new PageClass('Zones', 2, 'Zones.Map'));
        aThis.System.push(new PageClass('Analysis', 4, 'Analysis.Incidents.Details'));
        aThis.System.push(new PageClass('Reports', 36, 'Reports'));
        aThis.System.push(new PageClass('Inventory', 7, 'Inventory.Devices.Device'));
        aThis.System.push(new PageClass('Agents', 22, 'Agents.Agents.Profile'));

        aThis.Enrollees.push(new PageClass('Offenders', 21, 'Enrollees.Offenders.Profile.Events'));
        aThis.Enrollees.push(new PageClass('Victims', 21, 'Enrollees.Victims.Profile.Events'));

        aThis.EnrolleesOffenderPrimary.push(new PageClass('Profile', 13, 'Enrollees.Offenders.Profile.Events'));
        aThis.EnrolleesVictimPrimary.push(new PageClass('Profile', 13, 'Enrollees.Victims.Profile.Events'));
        aThis.EnrolleesOffenderPrimary.push(new PageClass('Map', 18, 'Enrollees.Offenders.Map.Events'));
        aThis.EnrolleesOffenderPrimary.push(new PageClass('SoberTrackReview', 16, 'Enrollees.Offenders.SoberTrackReview.Events'));
        aThis.EnrolleesVictimPrimary.push(new PageClass('Map', 18, 'Enrollees.Victims.Map.Events'));

        aThis.EnrolleesOffenderSecondary.push(new PageClass('Events', 1, 'Enrollees.Offenders.Profile.Events'));
        aThis.EnrolleesVictimSecondary.push(new PageClass('Events', 1, 'Enrollees.Victims.Profile.Events'));
        aThis.EnrolleesOffenderSecondary.push(new PageClass('Notes', 14, 'Enrollees.Offenders.Profile.Notes'));
        aThis.EnrolleesVictimSecondary.push(new PageClass('Notes', 14, 'Enrollees.Victims.Profile.Notes'));
        aThis.EnrolleesOffenderSecondary.push(new PageClass('Addresses', 15, 'Enrollees.Offenders.Profile.Addresses'));
        aThis.EnrolleesVictimSecondary.push(new PageClass('Addresses', 15, 'Enrollees.Victims.Profile.Addresses'));
        aThis.EnrolleesOffenderSecondary.push(new PageClass('Schedules', 16, 'Enrollees.Offenders.Profile.Schedules'));
        aThis.EnrolleesOffenderSecondary.push(new PageClass('SoberTrackSchedules', 16, 'Enrollees.Offenders.Profile.SoberTrackSchedules'));
        aThis.EnrolleesOffenderSecondary.push(new PageClass('Assignments', 17, 'Enrollees.Offenders.Profile.Assignments'));
        aThis.EnrolleesVictimSecondary.push(new PageClass('Assignments', 17, 'Enrollees.Victims.Profile.Assignments'));
        aThis.EnrolleesOffenderSecondary.push(new PageClass('ContactHistory', 10, 'Enrollees.Offenders.Profile.ContactHistory'));
        aThis.EnrolleesVictimSecondary.push(new PageClass('ContactHistory', 10, 'Enrollees.Victims.Profile.ContactHistory'));
        aThis.EnrolleesVictimSecondary.push(new PageClass('Notifications', 26, 'Enrollees.Victims.Profile.Notifications'));
        aThis.EnrolleesOffenderSecondary.push(new PageClass('Frp', 71, 'Enrollees.Offenders.Profile.Frp'));
        aThis.EnrolleesOffenderSecondary.push(new PageClass('EMA', 1, 'Enrollees.Offenders.Profile.EMA'));
        aThis.Analysis.push(new PageClass('Incidents', 5, 'Analysis.Incidents.Details'));
        aThis.Analysis.push(new PageClass('History', 6, 'Analysis.History.Details'));

        aThis.Inventory.push(new PageClass('Devices', 8, 'Inventory.Devices.Device'));
        aThis.Inventory.push(new PageClass('DeviceClusters', 11, 'Inventory.DeviceClusters.Device'));
        aThis.Inventory.push(new PageClass('KnownLocations', 11, 'Inventory.KnownLocations.Device'));
        aThis.Inventory.push(new PageClass('InventoryTileAnalysis', 111, 'Inventory.InventoryTileAnalysis.Device'));

        aThis.InventoryDevicesPrimary.push(new PageClass('Device', 8, 'Inventory.Devices.Device'));
        aThis.InventoryDevicesPrimary.push(new PageClass('AssignmentHistory', 9, 'Inventory.Devices.AssignmentHistory'));
        aThis.InventoryDevicesPrimary.push(new PageClass('ContactHistory', 10, 'Inventory.Devices.ContactHistory'));
        aThis.InventoryDevicesPrimary.push(new PageClass('BatteryHistory', 201, 'Inventory.Devices.BatteryHistory'));

        aThis.Agents.push(new PageClass('Agents', 23, 'Agents.Agents.Profile'));
        aThis.Agents.push(new PageClass('NotificationEscalationPlans', 30, 'Agents.NotificationEscalationPlans.Details'));

        aThis.Reports.push(new PageClass('Reports', 36, 'Reports.Reports.Details'));
        aThis.Reports.push(new PageClass('Schedules', 72, 'Reports.Schedules.Details'));

        aThis.ReportDetailsPrimary.push(new PageClass('Details', 36, 'Reports.Reports.Details'));


        aThis.ReportSchedulesPrimary.push(new PageClass('Details', 72, 'Reports.Schedules.Details'));

        aThis.ReportSchedulesSecondary.push(new PageClass('Filters', 73, 'Reports.Schedules.Details.Filters'));
        aThis.ReportSchedulesSecondary.push(new PageClass('Emails', 74, 'Reports.Schedules.Details.Emails'));

        aThis.AgentsDetailsPrimary.push(new PageClass('Profile', 24, 'Agents.Agents.Profile'));
        aThis.AgentsDetailsPrimary.push(new PageClass('CaseLoad', 13, 'Agents.Agents.CaseLoad'));

        aThis.AgentsDetailsPrimary.push(new PageClass('Zones', 13, 'Agents.Agents.Zones'));

        aThis.AgentsDetailsPrimary.push(new PageClass('DailyNotifications', 25, 'Agents.Agents.DailyNotifications'));
        aThis.AgentsDetailsPrimary.push(new PageClass('ImmediateNotifications', 26, 'Agents.Agents.ImmediateNotifications'));
        aThis.AgentsDetailsPrimary.push(new PageClass('RiskLevelPlans', 27, 'Agents.Agents.RiskLevelPlans'));
        aThis.AgentsDetailsPrimary.push(new PageClass('OffHours', 28, 'Agents.Agents.OffHours'));
        aThis.AgentsDetailsPrimary.push(new PageClass('Permissions', 29, 'Agents.Agents.Permissions'));
    };

    this.Initialize(this);
}
if (typeof exports !== 'undefined') {
    module.exports = PageClassManager;
}